<template lang="pug">
  .ssp-location-picker
    v-select(ref="locationPicker" :value.sync="value" :on-search="getOptions" :options="options" label="name" placeholder="Type location name" @input="onInput")
      template(slot="option" slot-scope="option")
        FamFlag(v-if="option.country" :code="option.country.code")
        span.description {{option.name}}
        span(v-if="option.country")  -  {{option.country.name}}
        em.text-muted(v-if="option.featureCode")  - {{option.featureCode}}
</template>

<script>
import vSelect from 'vue-select'
import debounce from 'debounce'
import TrackNTrace from '@/service/apis/TrackNTrace';
import FamFlag from '@/components/common/FamFlag'
import LocalStore from '@/service/LocalStore'

const recentBusinessLocationsStore = LocalStore.createList('location:recentBusinessLocations', 5)
const recentGeoLocationsStore = LocalStore.createList('location:recentGeoLocations', 5)

export default {
  name: 'LocationPicker',
  props: ['value', 'searchFunction'],
  data: () => ({
    options: []
  }),
  created() {
    this.getOptions = debounce(this.getOptions, 500)
  },
  mounted() {
    this.keyUpListener = this.$refs.locationPicker.$refs.search.addEventListener('keyup', (e) => { // TODO: Find non-hack for registering input
      if (!e.target.value) {
        this.setCachedOptions()
      }
    })

    if (this.searchFunction) {
      this.defaultSearchFunction = this.searchFunction
    }
    this.setCachedOptions()
  },
  beforeDestroy() {
    this.$refs.locationPicker.$refs.search.removeEventListener('keyup', this.keyUpListener)
  },
  methods: {
    getOptions(search, loading) {
      loading(true)
      const func = this.defaultSearchFunction()
      func({ name: search, size: 150, page: 0 })
        .then((resp) => {
          if (this.$refs.locationPicker.$refs.search.value) {
            this.options = resp.data.content
          }
        })
        .catch((e) => {
          this.$emit('error', e)
        })
        .then(() => loading(false))
    },
    setCachedOptions() {
      this.options = this.searchFunction ? recentGeoLocationsStore.get() : recentBusinessLocationsStore.get()
    },
    defaultSearchFunction() {
      return TrackNTrace.listBusinessLocations
    },
    onInput(val) {
      this.$emit('input', val)
    }
  },
  watch: {
    value(value) {
      if (value) {
        this.getOptions(value.name, () => { })
        if (this.searchFunction) {
          recentGeoLocationsStore.push(value)
        } else {
          recentBusinessLocationsStore.push(value)
        }
      }
    }
  },
  components: {
    vSelect,
    FamFlag
  }
}
</script>

<style lang="scss">
.ssp-location-picker {
  position: relative;
  .description {
    padding-left: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ssp/LocationPicker.vue